export default __webpack_public_path__ + "m_bg3ddfa88.png";